import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import { BUSINESS } from "@/constants";

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="bg-primary text-primary-foreground">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
                    <div>
                        <div className="flex items-center gap-2 font-heading font-semibold text-lg">
                            <Leaf className="h-5 w-5" aria-hidden="true" />
                            {BUSINESS.name}
                        </div>
                        <p data-testid="footer-address" className="mt-4 text-sm text-primary-foreground/80 leading-relaxed">
                            {BUSINESS.addressLines[0]}
                            <br />
                            {BUSINESS.addressLines[1]}
                        </p>
                    </div>
                    <div className="text-sm">
                        <h3 className="font-heading font-semibold">Legal</h3>
                        <Link
                            to="/privacy-policy"
                            data-testid="footer-privacy-link"
                            className="mt-3 inline-block text-primary-foreground/80 hover:text-primary-foreground underline-offset-4 hover:underline transition-colors"
                        >
                            Privacy Policy
                        </Link>
                    </div>
                </div>
                <div className="mt-10 pt-6 border-t border-primary-foreground/20 text-sm text-primary-foreground/70">
                    &copy; {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
                </div>
            </div>
        </footer>
    );
};
